import { flow, getParent, types, resolveIdentifier, getParentOfType } from 'mobx-state-tree';
// import { when } from 'mobx';
import Playlist from './Playlist';
import EducationStore from '../../stores/EducationStore';
import UIStore from '../../stores/UIStore';

const URL = 'education-center/v1';

const Video = types.model('video',{
  playlistId: types.optional(types.string, ''),
  displayIndex: types.optional(types.number, 0),
  videoId: types.optional(types.string, ''),
  title: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  url: types.optional(types.string, ''),
  videoProvider: types.optional(types.string, ''),
  videoProviderEnum: types.optional(types.number, 0),
  createdDatetime: types.optional(types.string, ''),
  deleted: types.optional(types.boolean, false),
  videoAmountPlayed: types.optional(types.number, 0),
  videoCurrentTime: types.optional(types.string,""),
  watched: types.optional(types.boolean, false),
  id: types.identifier()
}).views(self => ({
  get transport5007() {
    return getParent(self,2).transport5007;
  },
  get fetchMyLearning() {
    return getParentOfType(self, UIStore).dashboardStore.fetchMyLearning;
  }
})).actions(self=>({
  fetchWatchInfo: flow(function* fetchWatchInfo() {
    try {
      const { data: {videoAmountPlayed, videoCurrentTime, watched}  } = yield self.transport5007.fetch(
        `${URL}/UserVideos/${self.videoId}`,
        {},
        {}
      );
      // to reset all watch statuses:
      // yield self.saveWatchInfo(0,'');
      self.videoAmountPlayed = videoAmountPlayed;
      self.videoCurrentTime = videoCurrentTime;
      self.watched = watched;
    } catch (error) {
      if(error.response.status === 404) {
        return;
      }
      console.error('Getting Watch info failed: ', error);
    }
  }),
  setVideoWatched: flow(function* setVideoWatched() {
    try {
      const params={
        "videoId": self.videoId,
        "videoAmountPlayed": 1,
        "videoCurrentTime": ""
      }
      yield self.transport5007.put(
        `${URL}/UserVideos`,
        params,
        null,
        {}
      );
      self.watched = true;
      if(self.playlistId !== '' && getParent(self, 4).activePlaylists.includes(self.playlistId)) {
        self.fetchMyLearning();
      }
    } catch (error) {
      console.error('Setting Watch failed: ', error);
    }
  }),
  saveWatchInfo: flow(function* saveWatchInfo(amountPlayed, currentTime) {
    if(self.watched || self.videoAmountPlayed > amountPlayed) {
      return;
    }
    try {
      const params={
        "videoId": self.videoId,
        "videoAmountPlayed": `${amountPlayed}`,
        "videoCurrentTime": `${currentTime}`
      }
      yield self.transport5007.put(
        `${URL}/UserVideos`,
        params,
        null,
        {}
      );
      if(amountPlayed >= 0.9) {
        self.watched = true;
        if(self.playlistId !== '' && getParent(self, 4).activePlaylists.includes(self.playlistId)) {
          self.fetchMyLearning();
        }
      }
    } catch (error) {
      console.error('Setting Watch failed: ', error);
    }
  }),
  playNext() {
    // direct parent is always an array
    const educationStoreNode = getParentOfType(self, EducationStore)
    if(educationStoreNode) {
      let nextVideo;
      if(self.playlistId) {
        const parentPlaylist = resolveIdentifier(Playlist, educationStoreNode, self.playlistId);
        nextVideo = parentPlaylist.videos[self.displayIndex+1];
      } else {
        nextVideo = educationStoreNode.recommendedVideos[self.displayIndex+1];
      }
      if(nextVideo) {
        educationStoreNode.setCurrentVideo(nextVideo.id);
      }
    }
  }
}));

export default Video;
